import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "m-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("b", null, "New Features:", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, " Added search field on My Songs screen. ")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", null, "Fixed bugs:", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, " Fix direct link to View Song page not working and should not redirect to main page ")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("b", null, "New Features:", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, " Added Offline mode - user can see loaded during last online session songs, categories and band names. ")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("b", null, "New Features:", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, " Added Edit button to View Song page "),
  /*#__PURE__*/_createElementVNode("li", null, " Home page is change from Random to Songs list "),
  /*#__PURE__*/_createElementVNode("li", null, " Click on Update button during Edit Song will not try to redirect to Home "),
  /*#__PURE__*/_createElementVNode("li", null, " Current filtered categories will be visible in Song by different style "),
  /*#__PURE__*/_createElementVNode("li", null, " Click on Song's category will add and remove category filter ")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("b", null, "Fixed bugs:", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, " Filter backdrop is misplaced if open after scroll ")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("b", null, "New Features:", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, " Change name to MySongs "),
  /*#__PURE__*/_createElementVNode("li", null, " Edit Categories "),
  /*#__PURE__*/_createElementVNode("li", null, " Apply Categories colors "),
  /*#__PURE__*/_createElementVNode("li", null, " Add Categories to View Song and Songs list "),
  /*#__PURE__*/_createElementVNode("li", null, " Add Confirmation when go out of Add/Edit Song, to prevent data lost "),
  /*#__PURE__*/_createElementVNode("li", null, " Add Filtering by Categories and Bands ")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("b", null, "Fixed bugs:", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, " Songs hyperlinks to Tab or Lyrics not working "),
  /*#__PURE__*/_createElementVNode("li", null, " Navigation from Edit Song to Add New Song not working ")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("b", null, "New Features:", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, " View song list page "),
  /*#__PURE__*/_createElementVNode("li", null, " Random song page "),
  /*#__PURE__*/_createElementVNode("li", null, " Add song page ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, {
      elevation: 6,
      class: "m-3"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_title, { class: "d-flex justify-content-start" }, {
          default: _withCtx(() => [
            _createTextVNode(" v.3.1.0 ")
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [
            _hoisted_2,
            _hoisted_3,
            _hoisted_4,
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_card, {
      elevation: 6,
      class: "m-3"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_title, { class: "d-flex justify-content-start" }, {
          default: _withCtx(() => [
            _createTextVNode(" v.3.0.0 ")
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [
            _hoisted_6,
            _hoisted_7
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_card, {
      elevation: 6,
      class: "m-3"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_title, { class: "d-flex justify-content-start" }, {
          default: _withCtx(() => [
            _createTextVNode(" v.2.5.0 ")
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [
            _hoisted_8,
            _hoisted_9,
            _hoisted_10,
            _hoisted_11
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_card, {
      elevation: 6,
      class: "m-3"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_title, { class: "d-flex justify-content-start" }, {
          default: _withCtx(() => [
            _createTextVNode(" v.2.0.0 ")
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [
            _hoisted_12,
            _hoisted_13,
            _hoisted_14,
            _hoisted_15
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_card, {
      elevation: 6,
      class: "m-3"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_title, { class: "d-flex justify-content-start" }, {
          default: _withCtx(() => [
            _createTextVNode(" v.1.0.0 ")
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [
            _hoisted_16,
            _hoisted_17
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}